<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="saveFaq()" autocomplete="off">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Informações da Pergunta</h4>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="question">Pergunta <span class="text-danger">*</span></label>
                    <input
                      id="question"
                      v-model="faq.question"
                      name="question"
                      type="text"
                      class="form-control"
                      placeholder="Ex: Como faço para me inscrever no evento?"
                      :class="{
                        'is-invalid': submitted && $v.faq.question.$error,
                      }"
                    />
                    <div
                      v-if="submitted && !$v.faq.question.required"
                      class="invalid-feedback"
                    >
                      A pergunta é obrigatória.
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="answer">Resposta <span class="text-danger">*</span></label>
                    <textarea
                      id="answer"
                      v-model="faq.answer"
                      name="answer"
                      rows="5"
                      class="form-control"
                      placeholder="Digite a resposta completa..."
                      :class="{
                        'is-invalid': submitted && $v.faq.answer.$error,
                      }"
                    ></textarea>
                    <div
                      v-if="submitted && !$v.faq.answer.required"
                      class="invalid-feedback"
                    >
                      A resposta é obrigatória.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="float-right">
                <button type="button" @click="cancelar()" class="btn btn-dark mr-4">
                  Cancelar
                </button>
                <button type="submit" class="btn btn-primary mr-1">
                  Salvar
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    Layout,
    PageHeader
  },
  name: 'FAQ',
  page: {
    title: 'FAQ',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      faq: {
        id: '',
        question: '',
        answer: ''
      },
      submitted: false,
      title: 'Nova Pergunta',
      items: [
        {
          text: 'FAQs',
          href: '/faqs'
        },
        {
          text: 'Nova Pergunta',
          active: true
        }
      ]
    }
  },
  validations: {
    faq: {
      question: { required },
      answer: { required }
    }
  },
  mounted () {
    this.loadItem()
  },
  computed: {
    ...mapState('faqs', { data: 'faq' })
  },
  methods: {
    ...mapActions('faqs', {
      fetch: 'GetFaq',
      postData: 'SaveFaq'
    }),
    cancelar () {
      this.$router.push({ name: 'site-faqs' })
    },
    loadItem () {
      if (this.$route.params.id !== undefined) {
        let loader = this.$loading.show()
        this.items[1].text = 'Editar Pergunta'
        this.title = 'Editar Pergunta'
        this.fetch(this.$route.params.id)
          .then(() => {
            this.faq = this.data
          }).then(() => {
            loader.hide()
          })
      }
    },
    async saveFaq () {
      this.submitted = true
      this.$v.faq.$touch()
      if (this.$v.faq.$invalid) {
        window.scroll(0, 0)
        return
      }

      let loader = this.$loading.show()
      window.scroll(0, 0)

      await this.postData(this.faq).then(res => {
        let message = 'Sucesso: Dados armazenados com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.cancelar()
        loader.hide()
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        loader.hide()
      })
    }
  }
}
</script>
